module.exports = __webpack_public_path__ + "static/media/image3.2f438d54.jpg";